<template>
  <div class="flex items-center p-3 justify-between">
    <div class="w-full flex-grow">
      <div class="w-full flex justify-between items-center flex-grow">
        <div>
          <h5 class="font-medium leading-none">
            {{ serviceForm.form.title }}
          </h5>
          <div v-if="form.customerForm && form.customerForm.requestState" class="text-sm font-normal mt-1">
            <o-chip v-if="isRequestStateRequested" flat variant="warning" size="xs" square>
              {{ $t('form.requested') }}
            </o-chip>
            <o-chip v-if="isRequestStateCompleted" flat variant="success" size="xs" square>
              {{ $t('form.completed') }}
            </o-chip>
            <o-chip v-if="isRequestStateUpdateRequested" flat variant="warning" size="xs" square>
              {{ $t('form.updateRequested') }}
            </o-chip>
            <o-chip v-if="customerForm.consentAccepted" flat variant="info" size="xs" square>
              {{ $t('form.consentAccepted') }}
            </o-chip>
            <o-chip v-if="isRequestStateScheduled" variant="warning" flat size="xs" square>
              {{ $t('general.colonSeparator', { label1: $t('general.scheduled'), label2: scheduledLabel }) }}
            </o-chip>
          </div>
        </div>

        <div class="flex items-center space-x-1">
          <o-button v-if="!customerForm" size="sm" flat @click="handleAddForm()">
            {{ $t('general.add') }}
          </o-button>
          <o-button size="sm" flat @click="handleRequestForm()">
            {{ $t('general.request') }}
          </o-button>
          <o-button v-if="isRequirementModeScheduled" size="sm" flat @click="handleScheduleForm()">
            {{ $t('general.schedule') }}
          </o-button>
          <o-panel-link
            v-if="isRequestStateCompleted || isRequestStateUpdateRequested"
            tag="o-button"
            :path="`/customer/form/${customerForm.idCustomerForm}`"
            size="sm"
            flat
          >
            {{ $t('general.view') }}
          </o-panel-link>
        </div>
      </div>
    </div>

    <request-form-dialog
      ref="requestFormDialog"
      :customer="reservation.customer"
      :reservation="reservation"
      :select="false"
      @success="handleSuccess()"
    />

    <schedule-form-dialog
      ref="scheduleFormDialog"
      :customer="reservation.customer"
      :reservation="reservation"
      :select="false"
      :offset="serviceForm.scheduleOffset"
      @success="handleSuccess()"
    />

    <add-form-dialog
      ref="addFormDialog"
      :reservation="reservation"
      :select="false"
      :customer="reservation.customer"
    />
  </div>
</template>

<script setup lang="ts">
import RequestFormDialog from '@/components/customerForm/actions/Request.vue'
import ScheduleFormDialog from '@/components/customerForm/actions/Schedule.vue'
import AddFormDialog from '@/components/customerForm/actions/Add.vue'

const { $date, $i18n, $bus } = useNuxtApp()

interface Props {
  form: Record<string, any>
  reservation: Record<string, any>
}

const props = defineProps<Props>()

const requestFormDialog = ref<any>()
const scheduleFormDialog = ref<any>()
const addFormDialog = ref<any>()

const serviceForm = computed(() => props.form.serviceForm)
const customerForm = computed(() => props.form.customerForm)
const isRequirementModeScheduled = computed(() => serviceForm.value.isRequirementModeScheduled)
const isRequestStateRequested = computed(() => customerForm.value && customerForm.value.isRequestStateRequested)
const isRequestStateCompleted = computed(() => customerForm.value && customerForm.value.isRequestStateCompleted)
const isRequestStateUpdateRequested = computed(() => customerForm.value && customerForm.value.isRequestStateUpdateRequested)
const isRequestStateScheduled = computed(() => customerForm.value && customerForm.value.isRequestStateScheduled)

const scheduledLabel = computed(() => {
  if (props.form.form.automationEnabled) {
    const date = new Date(props.form.scheduledTime * 1000)
    const utc = $date.utc(date)
    const format = $date.presets.full
    const label = $date.format(utc, format)

    return label
  } else {
    return $i18n.t('general.disabled')
  }
})

function handleAddForm () {
  addFormDialog.value.open(serviceForm.value.form)
}

function handleRequestForm () {
  requestFormDialog.value.open(serviceForm.value.form)
}

function handleScheduleForm () {
  scheduleFormDialog.value.open(serviceForm.value.form)
}

function handleSuccess () {
  $bus.emit.updated('Reservation', props.reservation)
}
</script>
